import React from "react";
import "../styles/About.css";
import FadeInSection from "./FadeInSection";
import Lottie from 'lottie-react';
import animationData from './3animation.json';
import animationDat from './4animation.json';
import animationDa from './2animation.json';

class About extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1",
      email: "" // Store the email input value
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { email } = this.state;

    if (email) {
      console.log("Email submitted:", email);
      // You can perform any action here, like sending the email to a backend
    } else {
      alert("Please enter a valid email!");
    }
  }

  render() {
    const one = (
      <p>
        GroupMatch is designed to offer a fresh approach to dating by focusing on <strong>group dynamics</strong> and <strong>shared experiences</strong>. It allows users to connect in a safe, low-pressure environment where individuals can meet and socialize with others through group dates. It is redefining how singles meet and connect. 
      </p>
    );
    const two = (
      <p>
        Our Mission is to create <b>authentic connections</b> through fun activities and curated group events. Whether you're looking for friendship or romance, GroupMatch is about fostering meaningful interactions in a relaxed setting.
      </p>
    );
    const three = (
        <p>
          Sign up with your email to join our exclusive newsletter. Stay up-to-date with the latest news, exciting updates, and special offers from GroupMatch. 
        </p>
      );
    const four =(
      <p>We stand out because of our unique take on online dating. Users can <strong>sign up solo or with a friend to form a pair</strong>, and the app matches them with another compatible pair for a fun group outing. It’s not just about swiping—it’s about creating real experiences. The app includes advanced matchmaking algorithms, curated suggestions for double-date activities, and important safety features like profile verification and video introductions. It’s a modern solution that makes dating feel more like hanging out with friends than a high-pressure interview.

      </p>
    )
      
    const approach = (
      <div className="features-container">
      <div className="features-row">
        <div className="feature-card">
          <div className="feature-number">01</div>
          <h3 className="feature-title">Detailed Profiles</h3>
          <p className="feature-description">
            Share your interests and goals to get matched with the best group events.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">02</div>
          <h3 className="feature-title">Personalized Event Recommendations</h3>
          <p className="feature-description">
            Get event suggestions based on your social preferences and goals.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">03</div>
          <h3 className="feature-title">Icebreaker Prompts</h3>
          <p className="feature-description">
            Fun prompts to help start conversations at group events.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">04</div>
          <h3 className="feature-title">Group Compatibility Algorithm</h3>
          <p className="feature-description">
            Match with groups based on your interests and personality.
          </p>
        </div>
      </div>

      <div className="features-row">
        <div className="feature-card">
          <div className="feature-number">05</div>
          <h3 className="feature-title">Meaningful Interactions</h3>
          <p className="feature-description">
            Engage with specific members for authentic connections.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">06</div>
          <h3 className="feature-title">Transparent Connections</h3>
          <p className="feature-description">
            See who’s attending and who’s engaging with you.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">07</div>
          <h3 className="feature-title">Event Reminders</h3>
          <p className="feature-description">
            Get reminders for upcoming events and stay engaged.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-number">08</div>
          <h3 className="feature-title">Smart Socializing</h3>
          <p className="feature-description">
            Refined event suggestions based on your interactions.
          </p>
        </div>
      </div>
    </div>
        
      
    );
    
    const core_values = [
      "Inclusivity",
      "Safety",
      "Fun",
      "Authentic ",
      "Low-pressure Socializing",
      "Memorable Experiences"
    ];

    return (
      <div id="about">
        <FadeInSection>
          <div style={{ fontSize: '24px' }}>{[one]} 
            <br></br><h2><strong>What makes us different?</strong></h2>
            {[four]}</div>
          <div className="about-content">
            <div className="about-description">
              <p><h2>Our Values:</h2></p>
              <ul className="core-values">
                {core_values.map(function (value, i) {
                  return (
                    <FadeInSection delay={`${i + 1}00ms`}>
                      <li>{value}</li> 
                    </FadeInSection>
                  );
                })}
              </ul>
              <br /><br /> 
              <p><h2>Our Mission:</h2></p>
              {[two]}
            </div><br />
            <Lottie animationData={animationData}  />
          </div>
          <p ><h2>Our Approach:</h2></p>

          {[approach]}
          <br /><br /> 
        </FadeInSection>
        <div className="about-content"><br /><br /><br /><br /><Lottie animationData={animationDa}  />
          <div style={{ marginLeft: '20px' }}className="about-description"> <br /><br />Want to know more about how GroupMatch works? Get started today and meet new people in a fun, relaxed setting. We're excited to have you join the community!</div>
          
          </div>
        <div style={{ fontSize: '18px' }} className="form-container">
            <br /><br /><br /><br />
            {[three]}
            <form onSubmit={this.handleSubmit} className="form">
              <input 
                type="email" 
                placeholder="Enter your email" 
                required 
                value={this.state.email} 
                onChange={this.handleEmailChange} 
                className="email-input"
              />
              <button type="submit" className="submit-button">Submit</button>
            </form>

          </div>
          <Lottie animationData={animationDat}  />
      </div>

    );
  }
}

export default About;
